import { render } from "./DefaultNavbar.vue?vue&type=template&id=028f0327"
import script from "./DefaultNavbar.vue?vue&type=script&lang=js"
export * from "./DefaultNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__